<template lang="pug">
.__markup-yellow(:style="styles")
  .title {{ title }}
  nav-switcher.block(
    :items="switcher"
    :styleParams="styleParams"
  )
  form-filter.block(
    :action="filterAction"
    :fields="list"
    :button-text="buttonText"
    :styleParams="styleParams"
    @change="change"
    @submit="submit"
  )
</template>

<script>
// TODO, FIXIT - получился смешанный компонент (умный со стилями) - лучше разнести шаблон и данные

import { Switcher as NavSwitcher } from '@/components/parts/nav';
import { Filter as FormFilter } from '@/components/parts/form';
import colorSectionMenu from '@/mixins/colorSectionMenu';

export default {
  mixins: [colorSectionMenu],

  components: {
    FormFilter,
    NavSwitcher,
  },

  props: {
    route: String,
    nav: Array,

    title: {
      type: String,
      default: 'Гибкий поиск программ',
    },

    codeSection: {
      type: String,
      default: 'orientation',
    },

    codeSubsection: {
      type: String,
      default: 'profiling',
    },

    fields: {
      type: Array,
      default() {
        return [];
      },
    },

    routeSection: {
      type: String,
      default: 'section',
    },

    routeSubsection: {
      type: String,
      default: 'subsection',
    },

    values: {
      type: Object,
      default() {
        return {};
      },
    },

    buttonText: {
      type: String,
      default: 'Найти',
    },

    isForWidget: {
      type: Boolean,
      default: false,
    },

    widgetColor: {
      type: String,
      default: '',
    },

    regionStyle: {
      type: Object,
      default() {
        return {};
      },
    },

    hasSwitcher: {
      type: Boolean,
      default: true,
    },
  },

  mounted() {
    Object.keys(this.values).forEach((item) => {
      this.$set(this.current, item, this.values[item]);
    });
  },

  data() {
    return {
      current: {},
    };
  },

  computed: {
    switcher() {
      if (this.hasSwitcher) {
        return this.nav.map((item) => {
          let name = this.$route.name.split('-');
          name[0] = item.to.name;
          return {
            text: item.text,
            variant: item.variant,
            selected: item.selected,
            to: {
              name: name.join('-'),
              params: { ...this.$route.params },
              query: {
                ...(item.to.query || {}),
                ...this.$route.query,
              },
            },
          };
        });
      } else return [];
    },

    list() {
      // TODO FIXIT - переделать однонаправленный поток, чтобы в компоненте не оперировать данными
      return this.fields.map((item) => {
        const result = { ...item, value: this.values[item.code] };
        if (typeof item.filter === 'function')
          result.data = item.filter(item.data, this.current);
        return result;
      });
    },

    routeParams() {
      const {
        codeSection,
        codeSubsection,
        current,
        routeSection,
        routeSubsection,
      } = this;
      const params = {};
      if (current[codeSection]) params[routeSection] = current[codeSection];
      if (current[codeSubsection])
        params[routeSubsection] = current[codeSubsection];
      return params;
    },

    filterRoute() {
      return {
        name: this.route,
        params: this.routeParams,
      };
    },

    filterAction() {
      return this.$router.resolve(this.filterRoute).href;
    },

    styles() {
      const { $store, widgetColor } = this;
      if (!$store || !$store.state.regionProfile) {
        return widgetColor ? { backgroundColor: `#${widgetColor}` } : false;
      }
      const { colorSearch } = $store.state.regionProfile;
      return colorSearch ? { backgroundColor: `#${colorSearch}` } : false;
    },

    styleParams() {
      const { sectionMenuStyle, regionStyle } = this;
      return Object.keys(regionStyle).length ? regionStyle : sectionMenuStyle;
    },
  },

  watch: {
    list(newValue, oldValue) {
      // Проверяем, нужно ли сбросить предыдущий выбор, если теперь такого значения нет в options
      newValue.forEach((item) => {
        if (
          item.data &&
          item.code &&
          item.data.find((element) => {
            if (!element || !element.id) return false;
            return element.id == this.current[item.code];
          }) === undefined
        ) {
          this.$set(this.current, item.code, undefined);
        }
      });
    },
  },

  methods: {
    change(params) {
      let { code, value } = params;
      if (params) {
        this.$set(this.current, code, value);
        if (code === this.codeSection) {
          this.$set(this.current, this.codeSubsection, undefined);
        }
      }
      this.$emit('change', params);
    },

    submit() {
      this.$emit('filter-submit');
      if (!this.isForWidget) {
        this.$router.push({
          ...this.filterRoute,
          query: Object.keys(this.current)
            .filter(
              (item) =>
                this.current[item] !== undefined && this.current[item] !== null
            )
            .reduce((res, item) => {
              res[item] = this.current[item];
              return res;
            }, {}),
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.__markup-yellow {
  width: 100%;
  height: 100%;
  position: relative;
  height: 100%;
  box-sizing: border-box;
  background-color: #f59331;
  padding: 14px 20px;
  height: 100%;

  .title {
    line-height: 140%;
    text-transform: uppercase;
    color: #fff;
    font-family: Roboto, sans-serif;
    margin-bottom: 9px;
    font-size: 15px;
    text-align: center;
  }

  .block {
    margin-bottom: 17px;
  }
}
</style>



// WEBPACK FOOTER //
// Yellow.vue?02bd3750